import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import '@/lib/i18n'
import { AuthProvider } from '@/contexts/AuthContext'
import { TooltipProvider } from '@/components/ui/tooltip'
import { ReloadPrompt } from '@/components/ReloadPrompt'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <TooltipProvider delayDuration={0}>
        <BrowserRouter>
          <App />
          <ReloadPrompt />
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </React.StrictMode>,
)
